var alignment_rtlignore_default = {
  "alignLeft": "BbUAQ",
  "textWrapNowrap": "uLhzW",
  "alignRight": "NEkuN",
  "alignCenter": "UgLI2",
  "sizeFullWidth": "_1-NJa",
  "renderedInTable": "NINcZ",
  "sizeOriginal": "-Hzvr",
  "sizeContent": "cksCX",
  "sizeSmall": "DHKkJ",
  "sizeSmallCenter": "x-5SU",
  "flex": "Gk0Yg",
  "LEFT": "nSj-n",
  "CENTER": "OhQcF",
  "RIGHT": "K1RLQ",
  "AUTO": "INF6U",
  "JUSTIFY": "MVgY3"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
